module.exports = __webpack_public_path__ + "static/media/coxbazar.32162f64.png";